module.exports = __webpack_public_path__ + "img/2023102703.4d96d9ec.webp";